export default "__VITE_ASSET__c96647d0__"